<div class="language-selector">
  <div class="dropdown" (click)="toggleDropdown()">
    {{ langLabels[transloco.getActiveLang()] }}
    <span class="arrow">&#9662;</span>
  </div>
  <ul class="dropdown-menu" *ngIf="isOpen">
    <li *ngFor="let lang of langs"
        [class.active]="lang === transloco.getActiveLang()"
        (click)="selectLang(lang)">
      {{ langLabels[lang] }}
    </li>
  </ul>
</div>
